class StayAISubscriptions extends HTMLElement { 
  constructor() {
    super();
    this.productJSON = this.getAttribute("product-data");
    this.product = JSON.parse(this.productJSON);
    this.productFormId = this.getAttribute("product-form-id");
  }

  connectedCallback() {
    this.initWidget();
    this.setupEventListeners();
  }

  initWidget() {
    this.purchaseLabels = Array.from(
      this.querySelectorAll(".rtx-purchase-label")
    );

    this.sellingPlanGroups = this.product.selling_plan_groups.filter(
      (group) => group.app_id == "5859381"
    );

    this.currentVariant = this.product.variants[0];
    this.updateSellingPlans();
    if (this.sellingPlanGroups.length > 0)
      this.updateSellingPlanInput(
        this.sellingPlanGroups[0].selling_plans[0].id
      );
  }

  // Set up event listeners for the purchase type, frequency and variant selectors
  setupEventListeners() {
    const purchaseTypeRadioButtons = this.querySelectorAll(
      'input[name="purchaseType"]'
    );
    const variantSelectors = document.querySelectorAll('[name="id"]');

    //Update on load
    this.updateAddToCartPrice(purchaseTypeRadioButtons[0].value);

    // Handle purchase type change
    purchaseTypeRadioButtons.forEach((radio) =>
      radio.addEventListener("change", () => {
        let selectedOption = this.purchaseLabels.find(
          (label) => label.getAttribute("for") === "purchaseTypeOneTime"
        );
        if (radio.value != "") {
          selectedOption = this.purchaseLabels.find(
            (label) =>
              label.getAttribute("for") ===
              `purchaseTypeSubscription-${radio.value}`
          );
        }

        selectedOption.classList.toggle("is-selected", true);
        this.purchaseLabels.forEach((label) => {
          if (label !== selectedOption) {
            label.classList.toggle("is-selected", false);
          }
        });
        this.updateSavings(radio.value);
        this.updateSellingPlanInput(radio.value);
        this.updateAddToCartPrice(radio.value);
      })
    );

    // Handle variant change
    variantSelectors.forEach((selector) =>
      selector.addEventListener("change", ({ target }) => {
        const variantId = Number(target.value);
        this.currentVariant = this.product.variants.find(
          (v) => v.id === variantId
        );

        this.updateSellingPlans();
        this.updateAddToCartPrice(this.selectedSellingPlanOptionID());
      })
    );
  }

  //Update savings
  updateSavings(sellingPlanID) {
    // Clear all savings
    this.querySelectorAll(".savings").forEach(
      (savings) => (savings.innerHTML = "")
    );

    // Get the variant price and compare-at price
    const variantPrice = this.currentVariant.price / 100;
    const compareAtPrice = this.currentVariant.compare_at_price / 100;
    let fullSavings = 0;
    if (compareAtPrice > variantPrice && compareAtPrice > 0) {
      fullSavings = compareAtPrice - variantPrice;
    }

    if (sellingPlanID != "") {
      const subPrice =
        this.currentVariant.selling_plan_allocations.find(
          (spa) => spa.selling_plan_id == sellingPlanID
        ).price / 100;

      fullSavings =
        (fullSavings > 0 ? compareAtPrice : variantPrice) - subPrice;
    }
    if (fullSavings > 0)
      this.purchaseLabels
        .find((lbl) => lbl.classList.contains("is-selected"))
        .querySelector(".savings").innerHTML = `- Save $${Math.round(
        fullSavings
      )}`;
  }

  //Update add to cart price
  // updateAddToCartPrice(sellingPlanID) {
  //   const price = document.querySelector(".product-form__add .price");
  //   const oneTimePrice =
  //     this.currentVariant.compare_at_price &&
  //     this.currentVariant.compare_at_price > this.currentVariant.price
  //       ? `<s>${this.formatMoney(this.currentVariant.compare_at_price)}</s> `
  //       : `<s>${this.formatMoney(this.currentVariant.price)}</s> `;

  //   if (price) {
  //     if (sellingPlanID == "") {
  //       price.innerHTML = `
  //       ${
  //         this.currentVariant.compare_at_price &&
  //         this.currentVariant.compare_at_price > this.currentVariant.price
  //           ? `<s>${this.formatMoney(
  //               this.currentVariant.compare_at_price
  //             )}</s> `
  //           : ""
  //       }
  //        ${this.formatMoney(this.currentVariant.price)} -`;
  //     } else {
  //       const subPrice = this.formatMoney(
  //         this.currentVariant.selling_plan_allocations.find(
  //           (spa) => spa.selling_plan_id == sellingPlanID
  //         ).price
  //       );
  //       price.innerHTML = `${oneTimePrice} ${subPrice} -`;
  //     }
  //   }
  // }
      updateAddToCartPrice(sellingPlanID) {
        const mainPrice = document.querySelector(".product-form__add .price");
      
        const oneTimePriceElement = document.querySelector(".custom-onetime-price");
        const subscribePriceElement = document.querySelector(".custom-subscribe-price");
      
        const variant = this.currentVariant;
        const compareAt = variant.compare_at_price;
        const regularPrice = variant.price;
      
        const formattedCompare = this.formatMoney(compareAt);
        const formattedRegular = this.formatMoney(regularPrice);
      
        // One-time price block
        if (oneTimePriceElement) {
          if (compareAt > regularPrice) {
            oneTimePriceElement.innerHTML = `<s><span class="patrol-sr-only">Regular Price:</span>${formattedCompare}</s> <span>${formattedRegular}</span>`;
          } else {
            oneTimePriceElement.innerHTML = `<span><span class="patrol-sr-only">Sale Price:</span>${formattedRegular}</span>`;
          }
        }
      
        // Subscription price block
        if (subscribePriceElement && sellingPlanID) {
          const allocation = variant.selling_plan_allocations.find(
            (spa) => spa.selling_plan_id == sellingPlanID
          );
          if (allocation) {
            const subPrice = this.formatMoney(allocation.price);
            subscribePriceElement.innerHTML = `<s><span class="patrol-sr-only">Regular Price:</span>${formattedRegular}</s> <span style="color:var(--patrol-red-3);"><span class="patrol-sr-only">Sale Price:</span>${subPrice}</span>`;
          }
        }
      
        // Also update main price
        if (mainPrice) {
          if (sellingPlanID && variant.selling_plan_allocations.length > 0) {
            const subPrice = this.formatMoney(
              variant.selling_plan_allocations.find((spa) => spa.selling_plan_id == sellingPlanID).price
            );
            mainPrice.innerHTML = `<s><span class="patrol-sr-only">Regular Price:</span>${formattedRegular}</s> <span><span class="patrol-sr-only">Sale Price:</span>${subPrice}</span>`;
          } else {
            mainPrice.innerHTML = compareAt > regularPrice
              ? `<s><span class="patrol-sr-only">Regular Price:</span>${formattedCompare}</s> <span class="patrol-sr-only">Sale Price:</span>${formattedRegular}`
              : `${formattedRegular}`;
          }
        }
      }



  // Populate the subscription frequency selector with selling plans for the current variant
  updateSellingPlans() {
    // Get the selling plans for the current variant
    const stayWidget = this.querySelector(`.stay-ai-subscriptions`);
    const sellingPlans = this.currentVariant.selling_plan_allocations
      .map((spa) =>
        this.sellingPlanGroups
          .find((g) => g.id === spa.selling_plan_group_id)
          ?.selling_plans.find((sp) => sp.id === spa.selling_plan_id)
      )
      .filter(Boolean);

    if (sellingPlans.length == 0) {
      this.updateSellingPlanInput("");
      stayWidget.classList.toggle("is-visible", false);
      console.log("No SPs, hiding widget");
      return;
    } else stayWidget.classList.toggle("is-visible", true);

    // Update options
    const subLabels = this.querySelectorAll(".sub .subscription-label");
    sellingPlans.forEach((sp, i) => {
      subLabels[
        i
      ].innerHTML = `${sp.options[0].value} <span class="savings"></span>`;
    });
    this.updateSavings(this.selectedSellingPlanOptionID());
  }

  // Check if subscription option is selected and return the SP ID
  selectedSellingPlanOptionID() {
    return this.purchaseLabels
      .find((lbl) => lbl.classList.contains("is-selected"))
      .querySelector("input").value;
  }

  //Add selling plan input to form with specified selling plan ID
  updateSellingPlanInput(sellingPlanId) {
    if (!sellingPlanId) {
      sellingPlanId = this.selectedSellingPlanOptionID();
    }
    const productForm = document.querySelector(
      this.productFormId?.trim()
        ? `#${this.productFormId}`
        : `form[action='/cart/add'][data-type='add-to-cart-form']`
    );

    if (!productForm) return;

    // Find or create the hidden input for selling plan
    let sellingPlanInput = productForm.querySelector(
      "input[name='selling_plan']"
    );
    if (!sellingPlanInput) {
      sellingPlanInput = document.createElement("input");
      sellingPlanInput.type = "hidden";
      sellingPlanInput.name = "selling_plan";
      sellingPlanInput.value = sellingPlanId;
      productForm.appendChild(sellingPlanInput);
    } else {
      sellingPlanInput.value = sellingPlanId;
    }
  }

  // Format money based on Shopify's active currency
  formatMoney(money) {
    const currencySymbols = {
      USD: "$",
      EUR: "€",
      GBP: "£",
      JPY: "¥",
      CAD: "C$",
      AUD: "A$",
      CHF: "CHF",
      CNY: "¥",
      SEK: "kr",
      NZD: "NZ$",
    };

    const activeCurrency = Shopify.currency.active;
    const currencySymbol = currencySymbols[activeCurrency] || activeCurrency;
    let formattedMoney = (money / 100).toFixed(2);
    formattedMoney = formattedMoney.endsWith(".00")
      ? formattedMoney.slice(0, -3)
      : formattedMoney;

    var formatted;

    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
        formatted = window.Shopify.formatMoney(money);
        if (formatted) return formatted;
      }

      if (
        window.theme &&
        window.theme.utils &&
        typeof window.theme.utils.formatMoney === "function"
      ) {
        formatted = theme.utils.formatMoney(money);
        if (formatted) return formatted;
      }
      return `${currencySymbol}${formattedMoney}`;
    } catch (error) {
      console.error("Error formatting money:", error);
      return `${currencySymbols["USD"]}${formattedMoney}`;
    }
  }
}

// Define the custom element
customElements.define("purchase-options", StayAISubscriptions);


document.addEventListener("DOMContentLoaded", function () {
  const oneTimeRadio = document.querySelector('input[name="custom-purchaseType"][value="onetime"]');
  const subscribeRadio = document.querySelector('input[name="custom-purchaseType"][value="subscribe"]');
  const freqWrapper = document.getElementById("frequency-select-wrapper");
  const freqSelect = document.getElementById("custom-frequency-select");
  const oneTimeItem = oneTimeRadio.closest(".purchase-item");
  const subscribeItem = subscribeRadio.closest(".purchase-item");

  // Click corresponding StayAI radio input
  function triggerStayAIRadioInput(inputId) {
    const input = document.getElementById(inputId);
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function updateActiveClass() {
    if (subscribeRadio.checked) {
      subscribeItem.classList.add("active");
      oneTimeItem.classList.remove("active");
    } else {
      oneTimeItem.classList.add("active");
      subscribeItem.classList.remove("active");
    }
  }
  // Handle One-Time
  oneTimeRadio.addEventListener("change", () => {
    if (oneTimeRadio.checked) {
      freqWrapper.style.display = "none";
       updateActiveClass();
      triggerStayAIRadioInput("purchaseTypeOneTime");
    }
  });

  // Handle Subscribe
  subscribeRadio.addEventListener("change", () => {
    if (subscribeRadio.checked) {
      freqWrapper.style.display = "block";
        updateActiveClass();
      const selectedId = "purchaseTypeSubscription-" + freqSelect.value;
      triggerStayAIRadioInput(selectedId);
    }
  });

  // Handle dropdown change (simulate click on StayAI input)
  freqSelect.addEventListener("change", () => {
    const selectedId = "purchaseTypeSubscription-" + freqSelect.value;
    triggerStayAIRadioInput(selectedId);
  });

  // Initial setup
  if (subscribeRadio.checked) {
    freqWrapper.style.display = "block";
    const selectedId = "purchaseTypeSubscription-" + freqSelect.value;
    triggerStayAIRadioInput(selectedId);
  } else {
    freqWrapper.style.display = "none";
    triggerStayAIRadioInput("purchaseTypeOneTime");
  }
  updateActiveClass();
});



const observer = new MutationObserver(() => {
  const giftButton = document.querySelector(".givy_send_as_gift_button");
  const subDescText = document.querySelector(".subDescText");

  if (giftButton && subDescText && !giftButton.classList.contains("moved-below-subdesc")) {
    subDescText.insertAdjacentElement("afterend", giftButton);
    giftButton.classList.add("moved-below-subdesc"); // prevent multiple moves
    observer.disconnect(); // stop watching once done
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

